const en = {
  // Navigation
  'nav.dashboard': 'Dashboard',
  'nav.calendar': 'Calendar',
  'nav.statistics': 'Statistics',
  'nav.callLog': 'Call Log',
  'nav.habits': 'Habits',
  'nav.settings': 'Settings',
  'nav.admin': 'Admin',
  'nav.signOut': 'Sign out',

  // App
  'app.title': 'Zman',
  'app.subtitle': 'CodeLab',

  // Auth
  'auth.login': 'Log In',
  'auth.signup': 'Sign Up',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.fullName': 'Full Name',
  'auth.forgotPassword': 'Forgot password?',
  'auth.resetPassword': 'Reset Password',
  'auth.sendResetLink': 'Send Reset Link',
  'auth.backToLogin': 'Back to login',
  'auth.resetEmailSent': 'If an account exists for this email, a password reset link has been sent.',
  'auth.newPassword': 'New Password',
  'auth.confirmPassword': 'Confirm Password',
  'auth.updatePassword': 'Update Password',
  'auth.passwordUpdated': 'Your password has been updated. You can now log in.',

  // Dashboard
  'dashboard.todayStatus': "Today's Status",
  'dashboard.morningReminder': 'Morning Reminder',
  'dashboard.bedtimeReminder': 'Bedtime Reminder',
  'dashboard.streak': 'Streak',
  'dashboard.currentStreak': 'Current Streak',
  'dashboard.longestStreak': 'Longest Streak',
  'dashboard.zmanim': 'Zmanim',
  'dashboard.sunsetIn': 'Sunset in',
  'dashboard.upcomingReminders': 'Upcoming Reminders',
  'dashboard.weeklyBreakdown': 'Weekly Breakdown',
  'dashboard.monthlyTrend': 'Monthly Trend',

  // Statuses
  'status.onTime': 'On Time',
  'status.early': 'Early',
  'status.late': 'Late',
  'status.missed': 'Missed',
  'status.pending': 'Pending',
  'status.shabbat': 'Shabbat',
  'status.holiday': 'Holiday',

  // Settings
  'settings.title': 'Settings',
  'settings.language': 'Display Language',
  'settings.languageRegion': 'Language & Region',
  'settings.timezone': 'Timezone',
  'settings.shabbatMode': 'Shabbat Mode',
  'settings.holidayMode': 'Holiday Mode',
  'settings.save': 'Save Changes',
  'settings.saved': 'Settings saved',

  // Common
  'common.loading': 'Loading...',
  'common.today': 'Today',
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.close': 'Close',
  'common.search': 'Search',
  'common.noData': 'No data available',

  // Jewish calendar
  'jewish.shabbatShalom': 'Shabbat Shalom',
  'jewish.chagSameach': 'Chag Sameach',
  'jewish.candleLighting': 'Candle Lighting',
  'jewish.havdalah': 'Havdalah',
  'jewish.parshat': 'Parshat',
  'jewish.roshChodesh': 'Rosh Chodesh',

  // Pricing
  'pricing.title': 'Choose Your Plan',
  'pricing.subtitle': 'Automated accountability calls that actually build habits.',
  'pricing.planName': 'Personal',
  'pricing.price': '$7',
  'pricing.perMonth': '/month',
  'pricing.trialNote': 'Start with a 7-day free trial. Cancel anytime.',
  'pricing.feature.calls': 'Daily automated reminder calls',
  'pricing.feature.habits': 'Unlimited habits & schedules',
  'pricing.feature.streaks': 'Streak tracking & statistics',
  'pricing.feature.zmanim': 'Full Hebrew calendar & Zmanim',
  'pricing.feature.multilang': 'English, Hebrew & Yiddish',
  'pricing.startTrial': 'Start 7-day free trial',
  'pricing.processing': 'Redirecting...',

  // Subscription (settings)
  'subscription.title': 'Subscription',
  'subscription.status': 'Status',
  'subscription.plan': 'Plan',
  'subscription.renews': 'Renews',
  'subscription.trialEnds': 'Trial ends',
  'subscription.cancelsOn': 'Cancels on',
  'subscription.manageBilling': 'Manage billing',
  'subscription.subscribe': 'Subscribe',
  'subscription.none': 'You have no active subscription.',
  'subscription.status.active': 'Active',
  'subscription.status.trialing': 'Trial',
  'subscription.status.past_due': 'Past due',
  'subscription.status.canceled': 'Canceled',
  'subscription.status.incomplete': 'Incomplete',
  'subscription.status.unpaid': 'Unpaid',

  // Admin billing toggle
  'admin.billing.title': 'Billing',
  'admin.billing.toggle': 'Enable paid subscriptions',
  'admin.billing.help': 'When off, the app is fully free and phone calls run for every user. When on, only subscribed users receive calls.',
  'admin.billing.on': 'On',
  'admin.billing.off': 'Off',
};

export default en;
